import {Component, NgZone,  OnInit} from '@angular/core';
import {Chart} from 'angular-highcharts';
import {DataService} from '../../services/data.service';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-claim-data',
  templateUrl: './claim-data.component.html',
  styleUrls: ['./claim-data.component.scss']
})
export class ClaimDataComponent implements OnInit {
  totalData: any;
  statesValues: any;
  refreshChart: any;
  injuryData: any;
  propertyData: any;
  vehicleData: any;
  chart: any;
  incidentClaim: any;
  propertyClaim: any;
  vehicleClaim: any;
  number: any;
  constructor(private dataService: DataService, private zone: NgZone, private http: HttpClient) {
    this.refreshChart = false;
  }

  ngOnInit() {
    this.dataService.message.subscribe( data => { this.addDataPoint(data); });
    this.incidentClaim = 0;
    this.vehicleClaim = 0;
    this.propertyClaim = 0;
    this.number = 0;
  }

  addDataPoint(data) {
    this.http.get('../assets/incident.json')
      .subscribe((res: any[]) => {
        const datasize = res;
        for (let i = 0; i < datasize.length; i++) {
          if (res[i]['incident_date'] === '31-01-2015') {
            this.number++;
            this.incidentClaim = this.incidentClaim + res[i]['injury_claim'];
            this.propertyClaim = this.propertyClaim + res[i]['property_claim'];
            this.vehicleClaim = this.vehicleClaim  + res[i]['vehicle_claim'];
          }
        }
        console.log(this.number);
        console.log(this.incidentClaim);
        console.log(this.propertyClaim);
        console.log(this.vehicleClaim);
      });
    this.statesValues = data['value'];
    this.refreshChart = data['remove'];
    this.chart = new Chart({
      chart: {
        type: 'bar'
      },
      title: {
        text: 'Claim Composition'
      },
      xAxis: {
        title: {
          text: 'Days'
        },
        categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        scrollbar: {
          enabled: true
        },
      },
      yAxis: {
        title: {
          text: 'Total Amount in $'
        },
        min: 0,
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      series: [ ]
    });
    // this.totalData = [[ [5265, 3254, 4215, 7215, 2545, 5054, 6234, 2423, 9323, 16136, 5432, 31546, 12032, 12000, 14012, 39133, 4444,
    //   5422, 30543, 4056, 7023, 2234, 5943, 6026, 2123, 19123, 16234, 5423, 12043],
    //   [12000, 2000, 3000, 2000, 12000, 3000, 4000, 12000, 14000, 10000, 31000, 12000, 12000, 14000, 19000, 4000, 8000, 5000, 3000, 4000
    //   , 7000, 2000, 5000, 6000, 2000, 9000, 16000, 5000, 8000],
    //   [2000, 9000, 3000, 2000, 28000, 3000, 4000, 12000, 14000, 10000, 21000, 12000, 12000, 14000, 19000, 14000, 8000, 5000, 3000, 4000,
    //   7000, 22000, 5000, 6000, 12000, 18000, 12000, 5000, 9000]],
    //   [[ 7000, 4000, 5000, 12000, 11000, 3000, 9000, 16000, 21000, 5000, 8000, 7000, 14000, 19000, 8000, 2000, 4000, 3000, 21000, 14000, 3000,
    //     7000, 20000, 5000, 3000, 27000, 10000, 19500, 5000, 3000, 14000],
    //     [19000, 14000, 17000, 11000, 4000, 7000, 18000, 6000, 15000, 8000, 10000, 4000, 23000, 11000, 6000, 9000, 4000, 13000, 17000, 13000, 9000,
    //       16000, 7000, 20000, 12000, 5000, 14000, 25000, 5000, 12000, 18000],
    //     [5000, 9000, 24000, 6000, 27000, 9000, 11000, 14000, 5000, 17000, 2000, 22000, 6000, 6000, 3000, 16000, 13000, 9000, 16000, 15000, 11000,
    //       4000, 17000, 8000, 5000, 5000, 18000, 14000, 4000, 7000, 21000]]];
    this.totalData = [[ [142110, 202330, 684905, 185550, 94550, 174180, 66910, 163050, 88660, 42880, 63590, 139420, 93870, 171410, 138320,
      94310, 216810, 116700, 73510, 100090, 150290, 143400, 174600, 110460, 109020, 94910, 94730, 101320],
      [126020, 207240, 60850, 174660, 92950, 180550, 72070, 143460, 85120, 58930, 31000, 56380, 152490, 102690, 184740, 114740, 106140, 182410,
        107830, 57180, 100640, 127420, 121280, 152150, 112030, 111710, 70530, 95550],
      [728390, 989270, 339850, 890840, 485840, 897340, 360710, 806250, 493480, 307310, 411450, 754990, 610510, 866600, 783890, 489630, 901850,
        574740, 354330, 545540, 674340, 734120, 779670, 598850, 705390, 441920, 423650, 973320]],

      [[ 126760, 64450, 152660, 98190, 33650, 144690, 182560, 155140, 145370, 199160, 80390, 167120, 144500, 167730, 100770, 127560, 130740,
        98170, 158820, 130160, 157680, 121750, 110380, 165590, 64110, 102840, 110980, 85520, 76330, 183990, 120820],
        [131890, 50350, 146560, 109220, 41630, 123880, 326750, 196540, 146120, 175920, 91190, 163270, 141500, 119070, 91450, 114200, 128830,
          114540, 212630, 150550, 163360, 121170, 114700, 168640, 12000, 78330, 83840, 139380, 83120, 77240, 191410, 131160],
        [609170, 312130, 816960, 437160, 217430, 715320, 1100710, 865340, 721690, 980380, 400240, 809310, 736030, 787780, 537740, 650890, 576980,
          494340, 953750, 716060, 816630, 620640, 501920, 760440, 356210, 418780, 532580, 14000, 439530, 408420, 801730, 737660]]];
    this.injuryData = this.totalData[this.statesValues][0];
    this.propertyData = this.totalData[this.statesValues][1];
    this.vehicleData = this.totalData[this.statesValues][2];
    this.chart.addSeries({
      name: 'injury claim',
      data: this.injuryData,
      type: undefined
    }, true, false);
    this.chart.addSeries({
      name: 'property claim',
      data: this.propertyData,
      type: undefined
    }, true, false);
    this.chart.addSeries({
      name: 'vehicle claim',
      data: this.vehicleData,
      type: undefined
    }, true, false);
  }
}
